import "./style.css";

export default class Nav {
  static selector = ".s-side-nav-login";

  constructor(block) {
    this.block = block;
    this.$close = block.querySelector("#close");
    this.$bg = block.querySelector("#nav-bg");
    this.$userMenu = block.querySelector("ul.user-menu");
    this.$loginButton = block.querySelector("#login-button .s-button");
    this.forgetPasswordButton = block.querySelector(".forget-password-cta");
    this.$backToSignIn = block.querySelector("#back-to-sign-in");
    this.$becomeAMember = block.querySelector("#become-a-member.bottom");
    this.$submitForgetPassword = block.querySelector(
      "#become-a-member__button-holder .submit .s-button"
    );
    this.$sendMailAgain = block.querySelector(".send-mail-again .s-button a");
    this.$navHeader = block.querySelector("#s-side-nav-header");

    window.__onForgetPasswordClick = this.onForgetPasswordClick.bind(this);
    this.addListeners();
  }

  closeMenu() {
    this.backToSignIn();
    this.$navHeader.innerHTML = "SIGN IN";
    this.block.querySelector("ul.forget-password").classList.remove("sent");
    window.__$user && window.__$user.click();
  }

  onLogin(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const form = this.block.querySelector("form");
    const username = this.block.querySelector("#s-username").value;
    const password = this.block.querySelector("#s-password").value;

    const user_login = this.block.querySelector(
      "#loginform-custom #user_login"
    );

    user_login.value = username;

    const user_pass = this.block.querySelector("#user_pass");
    user_pass.value = password;

    form.submit();
  }

  onForgetPasswordClick() {
    this.$navHeader.innerHTML = "PASSWORD RECOVERY";
    this.$userMenu.classList.add("slide");
    this.$becomeAMember.classList.add("slide");
  }

  backToSignIn() {
    this.$navHeader.innerHTML = "SIGN IN";
    this.$userMenu.classList.remove("slide");
    this.$becomeAMember.classList.remove("slide");
  }

  onForgetPasswordSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const form = this.block.querySelector("#lostpasswordform");
    const username = this.block.querySelector("#s-username-forget").value;
    const user_login = this.block.querySelector(
      "#lostpasswordform #user_login"
    );

    user_login.value = username;
    form.submit();
  }

  sendMailAgain(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.block.querySelector("ul.forget-password").classList.remove("sent");
  }

  addListeners() {
    const $a = this.block.querySelectorAll(".link-close a");

    $a.forEach(($link) => {
      $link.addEventListener("click", this.closeMenu.bind(this));
    });

    this.$bg.addEventListener("click", this.closeMenu.bind(this));
    this.$close.addEventListener("click", this.closeMenu.bind(this));
    this.$loginButton.addEventListener("click", this.onLogin.bind(this));
    this.forgetPasswordButton.addEventListener(
      "click",
      this.onForgetPasswordClick.bind(this)
    );
    this.$backToSignIn.addEventListener("click", this.backToSignIn.bind(this));
    this.$submitForgetPassword.addEventListener(
      "click",
      this.onForgetPasswordSubmit.bind(this)
    );

    this.$sendMailAgain.addEventListener(
      "click",
      this.sendMailAgain.bind(this)
    );

    const username = this.block.querySelector("#s-username");
    const password = this.block.querySelector("#s-password");
    username.addEventListener("keyup", (e) => {
      this.checkLogin(username.value, password.value);
    });

    password.addEventListener("keyup", (e) => {
      this.checkLogin(username.value, password.value);
    });

    const usernameForgot = this.block.querySelector("#s-username-forget");
    usernameForgot.addEventListener("keyup", (e) => {
      this.checkLoginPassword(usernameForgot.value);
    });
  }

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  checkLoginPassword(username) {
    let disabled = true;
    if (username !== "") {
      if (this.validateEmail(username)) {
        disabled = false;
      }
    }

    //if (!disabled) this.$submitForgetPassword.removeAttribute("disabled");
    //else this.$submitForgetPassword.setAttribute("disabled", "disabled");
  }

  checkLogin(username, password) {
    let disabled = true;
    if (username !== "" && password !== "") {
      if (this.validateEmail(username)) {
        disabled = false;
      }
    }

    //if (!disabled) this.$loginButton.removeAttribute("disabled");
    //else this.$loginButton.setAttribute("disabled", "disabled");
  }

  onReady() {}

  onScroll({ y }) {}
}
